import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0 mb-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "card card-body mb-0" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "form-group col-sm-12" }
const _hoisted_6 = { class: "navbar-nav overflow-auto flex-row gap-4" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Providers = _resolveComponent("Providers")!
  const _component_Cascades = _resolveComponent("Cascades")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("ul", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Tabs, (value, tab) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: tab,
                    class: "nav-item nav-item-spaced d-lg-block text-nowrap"
                  }, [
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _withModifiers(($event: any) => (_ctx.selectTab(value)), ["prevent"]),
                      class: _normalizeClass(["nav-link tab", {'active': _ctx.activeTabName === value}])
                    }, _toDisplayString(_ctx.helper.trans(`labels.${tab}`)), 11, _hoisted_7)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.activeTabName === _ctx.Tabs.providers)
        ? (_openBlock(), _createBlock(_component_Providers, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.activeTabName === _ctx.Tabs.cascades)
        ? (_openBlock(), _createBlock(_component_Cascades, { key: 1 }))
        : _createCommentVNode("", true)
    ])
  ]))
}